import React from 'react';
import styled from 'styled-components';
import FormInputEmailMobileValidation from './FormInputEmailMobileValidation';

const FormPayidAccountDetails = ({
  paytoAccountInformation,
  setPaytoAccountInformation,
  paytoAccountValidation,
  setPaytoAccountValidation,
  paytoAccountInformationRetry,
  numberMaskStr,
  setNumberMaskStr,
  onPaytoSystemError,
  suppressPayIdMessage,
}) => {
  return (
    <FormPayidAccountDetailsStyled>
      <FormInputEmailMobileValidation
        paytoAccountInformation={paytoAccountInformation}
        setPaytoAccountInformation={setPaytoAccountInformation}
        paytoAccountValidation={paytoAccountValidation}
        setPaytoAccountValidation={setPaytoAccountValidation}
        paytoAccountInformationRetry={paytoAccountInformationRetry}
        numberMaskStr={numberMaskStr}
        setNumberMaskStr={setNumberMaskStr}
        onPaytoSystemError={onPaytoSystemError}
        suppressPayIdMessage={suppressPayIdMessage}
      />
    </FormPayidAccountDetailsStyled>
  );
};

const FormPayidAccountDetailsStyled = styled.div`
  display: grid;
  margin-bottom: 34px;
`;

export default FormPayidAccountDetails;
